import { useForm, UseFormProps } from 'react-hook-form'
import { ZodSchema } from 'zod'

const zodResolver = (schema: ZodSchema) => async (values: Record<string, unknown>) => {
  const result = schema.safeParse(values)

  if (result.success) {
    return {
      values: result.data,
      errors: {},
    }
  }

  const errors: Record<string, { type: string; message: string }> = {}

  result.error.issues.forEach((issue) => {
    const path = issue.path.join('.')
    if (!path || errors[path]) {
      return
    }

    errors[path] = {
      type: issue.code,
      message: issue.message,
    }
  })

  return {
    values: {},
    errors,
  }
}

interface IUseHookFormProps extends UseFormProps {
  schema: ZodSchema
}

export const useHookForm = ({schema, ...rest}: IUseHookFormProps) => {
  return useForm({
    ...rest,
    resolver: zodResolver(schema)
  });
}
